// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemButton, // ✅ New in MUI v7
//   ListItemIcon,
//   ListItemText,
//   Divider,
//   Box,
//   Typography,
// } from "@mui/material";
// import { Dashboard, QrCode, SwapHoriz, Settings } from "@mui/icons-material";
// import { Link, useLocation } from "react-router-dom";
// import { ReactElement } from "react";

// const drawerWidth = 240;

// interface MenuItem {
//   path: string;
//   icon: ReactElement;
//   text: string;
// }

// const Sidebar = () => {
//   const location = useLocation();

//   const menuItems: MenuItem[] = [
//     { path: "/dashboard", icon: <Dashboard />, text: "Dashboard" },
//     { path: "/scanner", icon: <QrCode />, text: "Scanner" },
//     { path: "/trades", icon: <SwapHoriz />, text: "Trades" },
//     { path: "/settings", icon: <Settings />, text: "Settings" },
//   ];

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         "& .MuiDrawer-paper": {
//           width: drawerWidth,
//           boxSizing: "border-box",
//           bgcolor: "primary.main",
//           color: "white",
//         },
//       }}
//     >
//       <Box sx={{ p: 2, textAlign: "center", bgcolor: "primary.dark" }}>
//         <Typography variant="h6">Trading Dashboard</Typography>
//       </Box>
//       <Divider />
//       <List>
//         {menuItems.map((item) => (
//           <ListItem
//             key={item.path}
//             disablePadding // Removes extra padding
//           >
//             <ListItemButton
//               component={Link} // ✅ Uses React Router's Link
//               to={item.path}
//               selected={location.pathname === item.path}
//               sx={{
//                 "&.Mui-selected": {
//                   bgcolor: "rgba(255, 255, 255, 0.1)",
//                   borderLeft: "3px solid #1ABB9C",
//                 },
//                 "&:hover": {
//                   bgcolor: "rgba(255, 255, 255, 0.05)",
//                 },
//               }}
//             >
//               <ListItemIcon sx={{ color: "inherit" }}>{item.icon}</ListItemIcon>
//               <ListItemText primary={item.text} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar;

// Sidebar.tsx
import {
  Collapse,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ListAltIcon from "@mui/icons-material/ListAlt";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SettingsIcon from "@mui/icons-material/Settings";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const drawerWidthOpen = 240;
const drawerWidthClosed = 60;

interface NavItem {
  label: string;
  icon: React.ReactNode;
  path?: string;
  adminOnly: boolean;
  requiresZerodha?: boolean;
  submenu?: {
    label: string;
    icon: React.ReactNode;
    path: string;
  }[];
}

const navItems: NavItem[] = [
  { label: "Dashboard", icon: <DashboardIcon />, path: "/dashboard", adminOnly: true, requiresZerodha: true },
  { label: "Portfolio", icon: <AccountBalanceWalletIcon />, path: "/portfolio", adminOnly: true, requiresZerodha: true },
  { label: "Orders", icon: <ReceiptLongIcon />, path: "/orders", adminOnly: true, requiresZerodha: true },
  {
    label: "NIFTY Options",
    icon: <TrendingUpIcon />,
    adminOnly: false,
    submenu: [
      { label: "Overview", icon: <DashboardIcon />, path: "/options" },
      { label: "Option Chain", icon: <TrendingUpIcon />, path: "/options/chain" },
      { label: "Strategy Radar", icon: <ElectricBoltIcon />, path: "/options/strategies" },
      { label: "Active Positions", icon: <AccountBalanceWalletIcon />, path: "/options/positions" },
      { label: "Engine Logs", icon: <ListAltIcon />, path: "/options/logs" },
      { label: "Risk & Kill Switch", icon: <ManageAccountsIcon />, path: "/options/risk" },
      { label: "Backtest Lab", icon: <CandlestickChartIcon />, path: "/options/backtest" },
      { label: "Deep Statistics", icon: <CandlestickChartIcon />, path: "/options/stats" },
      { label: "Qualification", icon: <DashboardIcon />, path: "/options/qualification" },
      { label: "Shadow Mode", icon: <TrendingUpIcon />, path: "/options/shadow" },
      { label: "System Health", icon: <DashboardIcon />, path: "/options/health" },
      { label: "Data Health", icon: <DashboardIcon />, path: "/options/data-health" },
      { label: "Strategy Versions", icon: <ManageAccountsIcon />, path: "/options/versions" },
      { label: "My Trading Settings", icon: <SettingsIcon />, path: "/options/settings" },
    ],
  },
  {
    label: "Intraday Stocks",
    icon: <ElectricBoltIcon />,
    path: "/intraday-stocks",
    adminOnly: false
  },
  {
    label: "Trade Dashboard",
    icon: <CandlestickChartIcon />,
    path: "/trade-dashboard",
    adminOnly: false,
    requiresZerodha: true
  },
  // { label: "US Intraday", icon: <ElectricBoltIcon />, path: "/us/intraday-stocks", adminOnly: true },
  // { label: "US Dashboard", icon: <CandlestickChartIcon />, path: "/us/trade-dashboard", adminOnly: true },
  { label: "User Management", icon: <ManageAccountsIcon />, path: "/user/manage", adminOnly: true },
];

type Props = {
  open: boolean;
};

export default function Sidebar({ open }: Props) {
  const [submenuOpen, setSubmenuOpen] = useState<{ [key: string]: boolean }>({});
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [activeMenu, setActiveMenu] = useState<NavItem | null>(null);

  const navigate = useNavigate();
  const location = useLocation();
  const authContext = useContext(AuthContext);
  const isAdmin = authContext?.isAdmin || false;

  // Filter menu items based on user role
  const visibleNavItems = navItems.filter(item => !item.adminOnly || isAdmin);

  const toggleSubmenu = (label: string) => {
    setSubmenuOpen((prev) => ({
      ...prev,
      ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}), // Close others
      [label]: !prev[label],
    }));
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, item: NavItem) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(item);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setActiveMenu(null);
  };

  const isActive = (path?: string) => path ? location.pathname === path : false;
  return (
    <Drawer
      variant="permanent"
      sx={{
        width: open ? drawerWidthOpen : drawerWidthClosed,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? drawerWidthOpen : drawerWidthClosed,
          overflowX: "hidden",
          transition: "width 0.3s",
          whiteSpace: "nowrap",
          boxSizing: "border-box",
          backgroundColor: "#1f2a40",
          color: "#fff",
          marginTop: "115px",
        },
      }}
    >
      <List>
        {visibleNavItems.map((item) => {
          const hasSubmenu = item.submenu && item.submenu.length > 0;
          const isUnlinkedZerodha = item.requiresZerodha && isAdmin && !authContext?.user?.isZerodhaLinked;
          const isUsItem = item.path?.startsWith("/us/") || item.path?.includes("/us/");

          return (
            <div key={item.label}>
              <Tooltip title={!open ? (isUnlinkedZerodha ? `${item.label} (Zerodha Unlinked)` : item.label) : ""} placement="right" arrow>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    onClick={(e) => {
                      if (hasSubmenu) {
                        if (open) {
                          toggleSubmenu(item.label);
                        } else {
                          handleOpenMenu(e, item);
                        }
                      } else if (item.path) {
                        navigate(item.path);
                      }
                    }}
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                      bgcolor: isActive(item.path) ? "#2e3b55" : "transparent",
                      opacity: isUnlinkedZerodha ? 0.6 : 1,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : "auto",
                        justifyContent: "center",
                        color: isUnlinkedZerodha ? "#ff9800" : (isUsItem ? "#e4a473ff" : "#fff"),
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    {open && (
                      <>
                        <ListItemText
                          primary={item.label}
                          primaryTypographyProps={{
                            sx: { color: isUnlinkedZerodha ? "#ff9800" : (isUsItem ? "#e4a473ff" : "#fff") }
                          }}
                        />
                        {isUnlinkedZerodha && (
                          <Tooltip title="Zerodha account unlinked" placement="right">
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                backgroundColor: '#ff9800',
                                display: 'inline-block',
                                marginLeft: 8
                              }} />
                            </span>
                          </Tooltip>
                        )}
                        {hasSubmenu &&
                          (submenuOpen[item.label] ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          ))}
                      </>
                    )}
                  </ListItemButton>
                </ListItem>
              </Tooltip>

              {hasSubmenu && item.submenu && (
                <Collapse
                  in={submenuOpen[item.label] && open}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" disablePadding>
                    {item.submenu.map((sub) => (
                      <ListItemButton
                        key={sub.label}
                        sx={{
                          pl: 6,
                          bgcolor: isActive(sub.path)
                            ? "#2e3b55"
                            : "transparent",
                        }}
                        onClick={() => navigate(sub.path)}
                      >
                        <ListItemIcon sx={{ color: "#ccc" }}>
                          {sub.icon}
                        </ListItemIcon>
                        <ListItemText primary={sub.label} />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          );
        })}
      </List>

      {/* Floating Menu for Collapsed State */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#1f2a40",
            color: "#fff",
            minWidth: 160,
            boxShadow: "0px 5px 15px rgba(0,0,0,0.3)",
            border: "1px solid rgba(255,255,255,0.1)",
          }
        }}
      >
        {activeMenu?.submenu?.map((sub) => (
          <MenuItem
            key={sub.label}
            onClick={() => {
              navigate(sub.path);
              handleCloseMenu();
            }}
            sx={{
              fontSize: "0.9rem",
              py: 1,
              bgcolor: isActive(sub.path) ? "#2e3b55" : "transparent",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.08)",
              },
            }}
          >
            <ListItemIcon sx={{ color: "#ccc", minWidth: 35 }}>
              {sub.icon}
            </ListItemIcon>
            <ListItemText primary={sub.label} />
          </MenuItem>
        ))}
      </Menu>
    </Drawer>
  );
}
